import Service from "../Service";
import Vue from "vue";
const resource = "sleCriteriaCollection/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID },
        });
    },

    save(Crc, requestID) {
        return Service.post(resource + "save", Crc, {
            params: { requestID }
        });
    },

    list(RequestID ){
    return Service.post(resource + "list",{},{
    params:{RequestID: RequestID}
  });
 },

 GetUrllist(){     
  return Vue.prototype.$http.defaults.baseURL + "/sleCriteriaCollection/list"; 
 },

  client(client,RequestID ){
    return Service.post(resource + "client",{},{
    params:{search: client, RequestID: RequestID},
    
   });
   },

  GetUrlclient(){   
     
  return Vue.prototype.$http.defaults.baseURL + "/sleCriteriaCollection/client"; 
   },

}